export type CreateEnvironmentCopyRequestResponse = {};
